import {
    createAction,
    CustomStoreAddOn,
    FilterCollectionStore,
    on,
    RemoteCollectionStore,
    SortCollectionStore,
    StoreBuilder
} from "@softline/core";
import {Bestellung} from "../types/bestellung";
import {lastValueFrom} from "rxjs";
import {BestellungService} from "../services/bestellung-service";

type State = RemoteCollectionStore.State<Bestellung>;

const remoteCollectionStore = RemoteCollectionStore.create<Bestellung>();

const mutations = {
}

const getters = {
}

const actions = {
  scanBestellung: createAction<State, {type: string, code: string}, Bestellung>('llrKommissionierungBestellung/actions/scanBestellungen')
}

const LlrKommissionierungBestellungStoreExtension: CustomStoreAddOn<State, typeof mutations, typeof getters, typeof actions> = {
  mutations,
  getters,
  actions,
  feature: {
    getters: [
    ],
    actions: [
        on(actions.scanBestellung, async ({ params, injector, commit, featureName }) => {
            const service = injector.get(BestellungService);

            const result =  await lastValueFrom(service.scanBestellung(params.type, params.code));

            commit(
              featureName,
              remoteCollectionStore.mutations.addOrUpdate,
              result
            );
            return result;
        })
    ],
    mutations: [
    ]
  },
}

export const LlrBestellungStore = new StoreBuilder(remoteCollectionStore)
  .add(FilterCollectionStore.create<Bestellung>())
  .add(SortCollectionStore.create<Bestellung>())
  .add(LlrKommissionierungBestellungStoreExtension)
  .value;
